<svelte:head>
<!-- <title>Sistem Pemantauan Karhutla - SiPongi+</title> -->
<!-- <meta name="description" content="SiPongi+ Karhutla Monitoring Sistem" /> -->
</svelte:head>

<div class="app">
	<main>
		<slot />
	</main>
</div>